import { ConfirmInput, IconFont, ListPage, SearchInput, SignTitle, SvgIcon } from '@/components'
import { useEffect, useState } from 'react'
import {
  Table,
  Form,
  Typography,
  Divider,
  Space,
  Modal,
  Card,
  message,
  Button,
  Drawer,
  Input,
} from 'antd'
import styled from 'styled-components'
import { useGetProxyList, useDelProxy, usePutProxy, usePostProxy } from './utils'
import { Message } from '@/components/message'
import { t } from '@/i18n'
interface DataType {
  key: React.Key
  name: string
  age: number
  address: string
}

interface GroupItemProps {
  children: string
  id: string
  typeName: string
}
const { TextArea } = Input

const IPV4_SEGMENT = '(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)'
const IPV4_ADDRESS = `(?:${IPV4_SEGMENT}\\.){3}${IPV4_SEGMENT}`
const IPV6_ADDRESS = '[0-9a-fA-F:.%]+'
const DOMAIN_ADDRESS = '(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]{2,}'
const SITE_URL_REGEX = new RegExp(
  `^https?:\\/\\/(?:\\[${IPV6_ADDRESS}\\]|${IPV4_ADDRESS}|${DOMAIN_ADDRESS}|localhost)(?::\\d{1,5})?(?:[/?#].*)?$`,
  'i',
)

const normalizeProxyInput = (value: string = '') =>
  value
    .split(/\r?\n/)
    .map(item => item.trim())
    .filter(Boolean)

export const Proxy = props => {
  const { playItem } = props
  const [form] = Form.useForm()
  const [proxyList, getProxyList, proxyListLoading] = useGetProxyList()
  const [postProxy, postProxyLoading] = usePostProxy()
  const [putProxy, putLoading] = usePutProxy()
  const [delProxy, delLoading] = useDelProxy()
  const [filterParams, setFilterParams] = useState({ limit: 10, page: 1, search: null })

  let [idList, setIdList] = useState<React.Key[]>()
  const getList = () => {
    getProxyList({ pool_id: playItem.pool_id, ...filterParams }).catch(_ => {})
  }
  useEffect(() => {
    if (playItem?.pool_id) {
      // setSearch(null)
      // getProxyList({ pool_id: playItem.pool_id, ...filterParams }).catch(_ => {})
      getList()
    }
  }, [playItem.pool_id, filterParams])
  useEffect(() => {
    // console.log(123)
    setFilterParams({ limit: 10, page: 1, search: null })
  }, [playItem.pool_id])
  let [visibleShow, setVisibleShow] = useState({
    visible: false,
    portal_id: [],
  })
  let [addVisible, setAddVisible] = useState(false)

  const onFinish = values => {
    const proxyList = normalizeProxyInput(values?.ip)
    postProxy({ pool_id: playItem.pool_id, ip: proxyList })
      .then(() => {
        setAddVisible(false)
        getList()
      })
      .catch(err => {})
  }
  const del = id => {
    // 删除
    delProxy({ pool_id: playItem.pool_id, proxy_id: id })
      .then(res => {
        getList()
        setVisibleShow((visibleShow = { visible: false, portal_id: null }))
        setIdList([])
      })
      .catch(err => {})
  }
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setIdList(selectedRowKeys)
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  }
  const GroupIP = (prop: GroupItemProps) => {
    const { children, id, typeName } = prop

    const [isActive, setIsActive] = useState(false)

    return (
      <GroupItemContainer>
        <div className="text">{children}</div>
        {isActive ? (
          <ConfirmInput
            name={typeName as string}
            id={id}
            onCancel={() => {
              setIsActive(false)
              // setIsEditGroupIp(false)
            }}
            onOk={async name => {
              if (!(name || '').trim()) {
                // setIsEditGroupIp(false)
                setIsActive(false)
                return
              }
              var re = new RegExp('^(http|https)://', 'i')
              var match = re.test(name)
              if (!match) {
                Message.error(t('格式错误'))
                return
              }
              putProxy({ pool_id: playItem.pool_id, proxy_id: id, ip: name })
                .then(res => {
                  setIsActive(false)
                  getList()
                })
                .catch(_ => {})
            }}
          />
        ) : (
          <>
            <IconFont
              style={{ cursor: 'pointer', marginRight: '10px', fontSize: '16px' }}
              onClick={() => {
                setIsActive(true)
              }}
              type={'icon-huabanfuben'}
              className="delete-icon"
            />
          </>
        )}
      </GroupItemContainer>
    )
  }
  const columns = [
    {
      title: t('代理服务器'),
      dataIndex: 'site',
      width: '90%',
      render: (_, record) => (
        <div style={{ width: '300px' }}>
          <GroupIP children={record.ip} id={record.id} typeName={record.ip} />
        </div>
      ),
    },
    {
      width: '70px',
      title: t('操作'),
      render: (_: any, record) => (
        <Space split={<Divider type="vertical" />}>
          <Typography.Link
            onClick={() => {
              setVisibleShow({ visible: true, portal_id: [record.id] })
            }}
          >
            <span style={{ marginLeft: 8 }}>{t('删除')}</span>
          </Typography.Link>
        </Space>
      ),
    },
  ]

  return (
    <ListContainer>
      <ListPage
        key={playItem.pool_id}
        columns={columns as any}
        rowKey={(record: any) => record.id}
        cardProps={{
          title: (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>{t('代理服务器列表')}</div>
              <Button type="primary" onClick={() => setAddVisible(true)}>
                {t('添加')}
              </Button>
            </div>
          ),
        }}
        searchParams={filterParams}
        total={proxyList?.total}
        setSearchParams={setFilterParams}
        setSelectedRowKeys={setIdList}
        selectedRowKeys={idList}
        dataSource={proxyList?.items}
        cardTop={54}
        filterOption={{
          search: {
            type: 'input',
            label: t('代理服务器'),
          },
        }}
        // cardTop={48}
        loading={proxyListLoading}
        isAside
        onReset={() => {
          setFilterParams({ page: 1, limit: 10, search: null })
        }}
        batchOperation={
          <Space
            split={<Divider type={'vertical'} />}
            onClick={e => {
              e.stopPropagation()
            }}
          >
            <div>{t('批量操作')}</div>
            <Delete
              active={idList?.length > 0}
              onClick={() => {
                if (idList?.length > 0) {
                  setVisibleShow((visibleShow = { visible: true, portal_id: idList }))
                }
              }}
            >
              <div>
                <SvgIcon
                  name={idList?.length > 0 ? 'batch_remove' : 'batch_remove_ash'}
                  className="icon-delete"
                />

                <span>{t('批量删除')}</span>
              </div>
            </Delete>
          </Space>
        }
      />
      <AddDrawer
        visible={addVisible}
        title={<SignTitle show>{t('添加代理服务器')}</SignTitle>}
        // closable={false}
        onClose={() => {
          form.resetFields()
          setAddVisible(false)
        }}
        footer={
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <div>
              <Button
                onClick={() => {
                  form.resetFields()
                  setAddVisible(false)
                }}
              >
                {t('取消')}
              </Button>
              <Button
                onClick={() => {
                  form.submit()
                }}
                type="primary"
                style={{ marginLeft: '10px' }}
              >
                {t('添加')}
              </Button>
            </div>
          </div>
        }
      >
        <Form form={form} layout={'vertical'} onFinish={onFinish}>
          <Form.Item
            name="ip"
            label={t('代理服务器')}
            rules={[
              { required: true, message: '请输入代理服务器' },
              {
                validator: (_, val) => {
                  if (!val) {
                    return Promise.resolve()
                  }
                  const proxies = normalizeProxyInput(val)
                  const invalidProxy = proxies.find(proxy => !SITE_URL_REGEX.test(proxy))
                  if (invalidProxy) {
                    return Promise.reject('代理服务器格式错误，请输入合法的 http/https 链接')
                  }
                  const invalidPort = proxies.find(proxy => {
                    const portMatch = proxy.match(/:(\d{1,5})(?=[/?#]|$)/)
                    if (!portMatch) {
                      return false
                    }
                    const port = Number(portMatch[1])
                    return port < 1 || port > 65535
                  })
                  if (invalidPort) {
                    return Promise.reject('端口范围应为1-65535')
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <TextArea
              autoSize={{ minRows: 5 }}
              placeholder={t('多条IP以换行隔开：\nhttps://10.100.100.1\nhttps://10.100.100.1')}
            />
          </Form.Item>
        </Form>
      </AddDrawer>

      <Modal
        centered
        title={<SignTitle show>{t('提示')}</SignTitle>}
        visible={visibleShow.visible}
        onOk={() => del(visibleShow.portal_id)}
        onCancel={() => setVisibleShow((visibleShow = { visible: false, portal_id: null }))}
        confirmLoading={delLoading}
      >
        <Icon type={'icon-tixingshixin'} />
        <span>{t('此操作将永久删除，是否继续?')}</span>
      </Modal>
    </ListContainer>
  )
}

interface DeleteItem {
  active: boolean
}
const Delete = styled.div<DeleteItem>`
  width: 92px;
  height: 24px;
  line-height: 32px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  justify-content: center;
  transition: 0.3s;
  &:hover {
    background-color: #fff;
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`

const ListContainer = styled.div`
  height: 100%;
`

const Icon = styled(IconFont)`
  color: #faad14;
  font-size: 18px;
  margin-right: 12px;
  transform: translateY(2px);
`

const GroupItemContainer = styled.div`
  height: 16px;
  border-radius: 4px;
  margin-bottom: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  .delete-icon {
    color: #999;
    &:hover {
      color: #2e3d5e;
    }
  }
  .text {
    line-height: 1.5;
    /* flex-grow: 1; */
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ant-input-affix-wrapper {
    min-width: 300px;
    max-width: 300px;
  }
`

const AddDrawer = styled(Drawer)`
  .ant-drawer-close {
    width: 36px;
    height: 36px;
    background: #d8d6f4;
    box-shadow: -1px 4px 10px 0px #c7c7c7;
    border-radius: 6px;
    border: none;
    margin-right: 0px;
    color: #4238c9;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translate(-10px, 8px);
      box-shadow: 0 0 0 0;
    }

    .ant-drawer-close-x {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }

  .ant-drawer-header {
    height: 56px;
    background: #f2f0ff;
    border-bottom: none;
    margin: 0;
  }
`
